// ✅ Utilidades para recortar imagen usando Canvas (compatible con react-image-crop)

export async function getCroppedImg(image, crop, shape = "round") {
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d");

	if (!ctx) {
		return null;
	}

	const scaleX = image.naturalWidth / image.width;
	const scaleY = image.naturalHeight / image.height;
	const pixelRatio = window.devicePixelRatio;

	// ✅ Calcular dimensiones del canvas
	const cropX = crop.x * scaleX;
	const cropY = crop.y * scaleY;
	const cropWidth = crop.width * scaleX;
	const cropHeight = crop.height * scaleY;

	// ✅ Tamaño del canvas (cuadrado para círculo)
	const size = Math.max(cropWidth, cropHeight);
	canvas.width = size * pixelRatio;
	canvas.height = size * pixelRatio;

	ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
	ctx.imageSmoothingQuality = "high";

	// ✅ Dibujar imagen recortada
	ctx.drawImage(
		image,
		cropX,
		cropY,
		cropWidth,
		cropHeight,
		0,
		0,
		size,
		size
	);

	// ✅ Si es círculo, crear máscara circular
	if (shape === "round") {
		const centerX = size / 2;
		const centerY = size / 2;
		const radius = size / 2;

		// ✅ Crear path circular
		ctx.globalCompositeOperation = "destination-in";
		ctx.beginPath();
		ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
		ctx.fill();
	}

	return new Promise((resolve) => {
		canvas.toBlob((blob) => {
			if (!blob) {
				resolve(null);
				return;
			}
			const fileUrl = URL.createObjectURL(blob);
			resolve(fileUrl);
		}, "image/jpeg", 0.95);
	});
}

